import { render, staticRenderFns } from "./TabDebtorInvoices.vue?vue&type=template&id=150fb8cc&scoped=true&"
import script from "./TabDebtorInvoices.vue?vue&type=script&lang=js&"
export * from "./TabDebtorInvoices.vue?vue&type=script&lang=js&"
import style0 from "./TabDebtorInvoices.vue?vue&type=style&index=0&id=150fb8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150fb8cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
